require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-chronic-nuisance.json") })
        }
      }, "path---tags-chronic-nuisance");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-chronic-nuisance!./.cache/json/tags-chronic-nuisance.json
// module id = 994
// module chunks = 231608221292675